import { useQuery } from '@tanstack/react-query'
import { getOrganizations } from '~/services/organization'
import { organizationKeys } from '~/services/organization/keys'

export default function useOrganizations(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: organizationKeys.list(),
    queryFn: getOrganizations,
    retry: false,
    refetchOnWindowFocus: false,
    ...options,
  })
}
